import { apiFetch } from '../App/api'

export function leadership(actionObj) {
    let loading = 'LEADERSHIP_LOADING' 
    let success = 'LEADERSHIP_SUCCESS' 
    let errorMessage = 'Unable to load leadership'

    var url = 'http://calvarychapelyelm.org/api/leadership'

    let request = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    }
    
    return apiFetch(url, request, loading, success, errorMessage)
}